import { useTranslation } from 'react-i18next';
import { TaskTypeStatus, type TaskCardType } from '@econtractor/types';

interface TaskCardReturnedTabProps {
    task: TaskCardType;
}

export const canShowReturnedTab = (task: TaskCardType, userId: number): boolean => {
    if (Number(task.taskStatus) === TaskTypeStatus.ACCEPTED) return false;
    const comment = String(task.taskAnswerReject || '').trim();
    if (!comment) return false;
    if (!(userId > 0)) return false;
    return userId === Number(task.taskExecutor) || userId === Number(task.taskController);
};

const TaskCardReturnedTab = ({ task }: TaskCardReturnedTabProps) => {
    const { t } = useTranslation(['Tasks']);
    const comment = String(task.taskAnswerReject || '').trim();

    return (
        <section className="task-card-section">
            <div className="task-card-section__label">{t('labelRejectComment')}</div>
            {comment ? (
                <div className="task-card-panel" style={{ whiteSpace: 'pre-wrap' }}>
                    {comment}
                </div>
            ) : (
                <div className="task-card-empty text-muted">—</div>
            )}
        </section>
    );
};

export default TaskCardReturnedTab;
